import { withParams, ref } from 'vuelidate/lib/validators/common';

export var charactersSpecialForUrl = function charactersSpecialForUrl(otherProp) {
    return withParams({ type: otherProp }, function (value) {
        return !/[$%([\]=ª\º#·!|?¿^çÇ{}@';*&]/.test(value);
    });
};


//////////////////
// WEBPACK FOOTER
// ./src/validators/characters-special-for-url.js
// module id = ./src/validators/characters-special-for-url.js
// module chunks = 0 1 2 3 4 6 7 8 9 10 11 12 14 15 16